import { render, staticRenderFns } from "./marquee.vue?vue&type=template&id=674f6545&scoped=true&"
import script from "./marquee.vue?vue&type=script&lang=js&"
export * from "./marquee.vue?vue&type=script&lang=js&"
import style0 from "./marquee.vue?vue&type=style&index=0&id=674f6545&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "674f6545",
  null
  
)

export default component.exports